import ApiClient from 'shared-lib/api/client';

const options = {
    ignoredErrorCodes: [],
    loadingErrorCodes: [ 500, 501, 502, 503, 504, 505, 506, 507, 508, 510, 511 ],
};

export default new ApiClient(options);

